import { alert, hideLoader, showLoader } from "../plugins";
import { createAsyncAction } from "../utils/ajex";
import Services from "../api/services";
import * as aj from "../aj/index";
import M from "../strings";
import * as _query from "../framework/query";
import { SET_STORE_TARGET, LOAD_TARGET_QUESTIONS_TREE, LOAD_STORE_TARGETS, UPDATE_STORE_TARGETS, CLEAR_STORES, LOAD_ALLOWED_STORES, GET_STORES_STATS } from "./types";
import * as responses from "../api/responses";



export const loadStoreTargets = createAsyncAction(LOAD_STORE_TARGETS, data => {
    aj.dispatch({
        type: LOAD_STORE_TARGETS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get(`stores/${data.storeId}/targets`)
            .then((response) => {
                loadStoreTargets.complete({
                    targets: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadStoreTargets.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const updateStoreTargets = createAsyncAction(UPDATE_STORE_TARGETS, data => {
    aj.dispatch({
        type: UPDATE_STORE_TARGETS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.postJson(`stores/${data.storeId}/targets`, data.targets)
            .then((response) => {
                updateStoreTargets.complete();
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                updateStoreTargets.fail();
                reject();
            })
            .finally(hideLoader)
    })
});


export const loadTargetQuestionsTree = createAsyncAction(LOAD_TARGET_QUESTIONS_TREE, data => {
    aj.dispatch({
        type: LOAD_TARGET_QUESTIONS_TREE
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get(`stores/${data.storeId}/target-questions-tree`, data.categoryIds)
            .then((response) => {
                loadTargetQuestionsTree.complete({
                    questionsTree: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadTargetQuestionsTree.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const loadAllowedStores = createAsyncAction(LOAD_ALLOWED_STORES, data => {
    aj.dispatch({
        type: LOAD_ALLOWED_STORES
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get(`stores/${data.surveyTemplateId}/allowedStores`, data.surveyTemplateId)
            .then((response) => {
                loadAllowedStores.complete({
                    allowedStores: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadAllowedStores.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const setStoreTarget = (questionTemplateId, value) => aj.dispatch({type: SET_STORE_TARGET, questionTemplateId, value})
export const clearStores = () => aj.dispatch({type: CLEAR_STORES});

export const getStoresStats = createAsyncAction(GET_STORES_STATS, data => {
    aj.dispatch({
        type: GET_STORES_STATS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get(`stores/stats`)
            .then((response) => {
                getStoresStats.complete({
                    storesStats: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                getStoresStats.fail();
                reject();
            })
            .finally(hideLoader)
    })
})